import { useEffect, useState } from 'react'
import Header from '../components/Header'
import Menu from '../components/Menu'
import { CiEdit } from 'react-icons/ci'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAllContext } from '../context/AllContext'
import axios from 'axios'
import { toast } from 'react-toastify'

const UserInterests = () => {
    const { t } = useTranslation();
    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const {
        getUserDetails, userDetails,
        getArtType, artType,
        getArtwork, artwork,
        getParticipate, participate,
        getCommunicate, communicate,
    } = useAllContext()


    const [selectedArtTypeId, setSelectedArtTypeId] = useState([]);
    const [selectedArtWorkId, setSelectedArtWorkId] = useState([]);
    const [selectedParticipateId, setSelectedParticipateId] = useState([]);
    const [selectedCommunicateId, setSelectedCommunicateId] = useState([]);

    const handleToggle = (id, setter, currentState) => {
        setter(
            currentState.includes(id)
                ? currentState.filter(item => item !== id)
                : [...currentState, id]
        );
    };

    useEffect(() => {
        if (userDetails) {
            setSelectedArtTypeId(userDetails.art_types?.map(item => item._id) || []);
            setSelectedArtWorkId(userDetails.art_works?.map(item => item._id) || []);
            setSelectedParticipateId(userDetails.participates?.map(item => item._id) || []);
            setSelectedCommunicateId(userDetails.communicates?.map(item => item._id) || []);
        }
    }, [userDetails]);

    const formSubmit = async (e) => {
        e.preventDefault()

        const apiData = {
            userId: limitsUser._id,
            art_types: selectedArtTypeId,
            art_works: selectedArtWorkId,
            participates: selectedParticipateId,
            communicates: selectedCommunicateId
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/InterestsUserProfile`, apiData, {
                headers: {
                    Authorization: limitsUser.token
                }
            })
            const data = await response.data

            if (data.status === 1) {
                toast.success(data.message)
            } else {
                toast.error(data.message)
            }

        } catch (error) {
            console.log('Error:', error);
        }
    }

    useEffect(() => {
        if (limitsUser) {
            getUserDetails(limitsUser.token, limitsUser._id)
            getArtType(limitsUser.token)
            getArtwork(limitsUser.token)
            getParticipate(limitsUser.token)
            getCommunicate(limitsUser.token)
        }
    }, [])


    return (
        <>
            <div className='main-content'>
                <Header page={"profile2"} title={"User Interests"} backpage={'/profile'} />

                <div className='padding2'>
                    <div className='container'>
                        <div className='my-profile mb-5'>
                            {
                                userDetails?.profileImage ? userDetails.profileImage.split('/')[0] === "uploads" ? <img src={`${process.env.REACT_APP_IMAGES_URL}/${userDetails?.profileImage}`} crossOrigin="anonymous" className='img-fluid img1 d-block mx-auto' alt="" />
                                : <img src={`${userDetails?.profileImage}`} className='img-fluid img1 d-block mx-auto' alt="" />
                                : <img src={require('../assets/images/profile.png')} className='img-fluid img1 d-block mx-auto' alt="" />
                            }
                        </div>

                        <div className='profile-form'>
                            <form action="" className='form form1' onSubmit={formSubmit}>
                                <div className='mb-3'>
                                    <div className='d-flex align-items-center mb-3'>
                                        <div className='w-100 me-2'>
                                            <p className='mb-0 text-white'>Types of Art that I enjoy</p>
                                        </div>
                                        <div>
                                            <Link><CiEdit className='icon1' data-bs-toggle="modal" data-bs-target="#artModal" /></Link>
                                        </div>
                                    </div>

                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {
                                            artType?.filter(item => selectedArtTypeId.includes(item._id))
                                                .map(item => (
                                                    <span key={item._id} className='items'>
                                                        {item.art_type}
                                                    </span>
                                                ))
                                        }
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className='d-flex align-items-center mb-3'>
                                        <div className='w-100 me-2'>
                                            <p className='mb-0 text-white'>Type of Artwork that I create or do</p>
                                        </div>
                                        <div>
                                            <Link><CiEdit className='icon1' data-bs-toggle="modal" data-bs-target="#artworkModal" /></Link>
                                        </div>
                                    </div>

                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {
                                            artwork?.filter(item => selectedArtWorkId.includes(item._id))
                                                .map(item => (
                                                    <span key={item._id} className='items'>
                                                        {item.art_work}
                                                    </span>
                                                ))
                                        }
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <div className='d-flex align-items-center mb-3'>
                                        <div className='w-100 me-2'>
                                            <p className='mb-0 text-white'>How I prefer to participate</p>
                                        </div>
                                        <div>
                                            <Link><CiEdit className='icon1' data-bs-toggle="modal" data-bs-target="#participateModal" /></Link>
                                        </div>
                                    </div>

                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {
                                            participate?.filter(item => selectedParticipateId.includes(item._id))
                                                .map(item => (
                                                    <span key={item._id} className='items'>
                                                        {item.participate}
                                                    </span>
                                                ))
                                        }
                                    </div>

                                </div>

                                <div className='mb-3'>
                                    <div className='d-flex align-items-center mb-3'>
                                        <div className='w-100 me-2'>
                                            <p className='mb-0 text-white'>How we communicate</p>
                                        </div>
                                        <div>
                                            <Link><CiEdit className='icon1' data-bs-toggle="modal" data-bs-target="#communicateModal" /></Link>
                                        </div>
                                    </div>

                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {
                                            communicate?.filter(item => selectedCommunicateId.includes(item._id))
                                                .map(item => (
                                                    <span key={item._id} className='items'>
                                                        {item.communicate}
                                                    </span>
                                                ))
                                        }
                                    </div>

                                </div>

                                <div className='mt-4'>
                                    <button type='submit' className='btn btn1 w-100 mt-4'>Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* <!-- Art type Modal --> */}
                <div className="modal modal1 fade" id="artModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                {/* <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5> */}
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <div className='mb-3'>
                                    <h5 className='mb-3 text-white'>Types of Art that I enjoy</h5>

                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {artType?.length > 0 && artType.map((item, index) => (
                                            <Link
                                                key={index}
                                                to=""
                                                className={`items ${selectedArtTypeId.includes(item._id) ? 'active' : ''}`}
                                                onClick={(e) => handleToggle(item._id, setSelectedArtTypeId, selectedArtTypeId)}
                                            >
                                                {item.art_type}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                                {/* <div className='mt-4 text-center'>
                                    <button className='btn btn1 mt-4'>{t("Add")}</button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Artworks Modal */}
                <div className="modal modal1 fade" id="artworkModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <div className='mb-3'>
                                    <h5 className='mb-3 text-white'>Artworks I create or do</h5>
                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {artwork?.length > 0 && artwork.map((item, index) => (
                                            <Link
                                                key={index}
                                                to=""
                                                className={`items ${selectedArtWorkId.includes(item._id) ? 'active' : ''}`}
                                                onClick={() => handleToggle(item._id, setSelectedArtWorkId, selectedArtWorkId)}
                                            >
                                                {item.art_work}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Participate Modal */}
                <div className="modal modal1 fade" id="participateModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <div className='mb-3'>
                                    <h5 className='mb-3 text-white'>How I prefer to participate</h5>
                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {participate?.length > 0 && participate.map((item, index) => (
                                            <Link
                                                key={index}
                                                to=""
                                                className={`items ${selectedParticipateId.includes(item._id) ? 'active' : ''}`}
                                                onClick={() => handleToggle(item._id, setSelectedParticipateId, selectedParticipateId)}
                                            >
                                                {item.participate}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Communicate Modal */}
                <div className="modal modal1 fade" id="communicateModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" style={{ 'maxWidth': '600px' }}>
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0 pt-4 px-4">
                                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body p-4 p-md-5 scrollbar">
                                <div className='mb-3'>
                                    <h5 className='mb-3 text-white'>How we communicate</h5>
                                    <div className='interests-input d-flex flex-wrap gap-3'>
                                        {communicate?.length > 0 && communicate.map((item, index) => (
                                            <Link
                                                key={index}
                                                to=""
                                                className={`items ${selectedCommunicateId.includes(item._id) ? 'active' : ''}`}
                                                onClick={() => handleToggle(item._id, setSelectedCommunicateId, selectedCommunicateId)}
                                            >
                                                {item.communicate}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Menu />
            </div>
        </>
    )
}

export default UserInterests
